import request from "@/utils/request.js";

class Api {
  // 添加客服
  addUser(data) {
    return request({
      method: "post",
      url: "/user/add",
      data,
    });
  }
  // 客服列表
  userList(params) {
    return request({
      method: "get",
      url: "/user/list",
      params,
    });
  }
  // 搜索用户
  selectUser() {
    return request({
      method: "get",
      url: "/user/select/user/list",
    });
  }
  // 编辑客服
  editUser(data) {
    return request({
      method: "post",
      url: "/user/edit",
      data,
    });
  }
  // 删除客服
  deleteUser(data) {
    return request({
      method: "post",
      url: "/user/del",
      data,
    });
  }
  // 重置密码
  resetPassword(data) {
    return request({
      method: "post",
      url: "/user/reset_password",
      data,
    });
  }
  // 修改客服标签
  editTag(data) {
    return request({
      method: "post",
      url: "/user/tag",
      data,
    });
  }
}

export default new Api();
